import { RefractionForm } from '@ca/common'
import { FieldValues, Path } from 'react-hook-form'

export type RefractionFormKeys = keyof RefractionForm
export type SelectedKey<T extends FieldValues> = Path<T> | null
export type SelectedKeySetter<T extends FieldValues> = (
  name: SelectedKey<T>
) => void

export type SelectedState = {
  [K in RefractionFormKeys]: RefractionForm[K] | null
}
export const inputsOrder: Path<RefractionForm>[] = [
  'r_sph',
  'l_sph',
  'r_cyl',
  'l_cyl',
  'r_axis',
  'l_axis',
  'r_add',
  'l_add',
  'r_visus',
  'l_visus',
  'r_pd',
  'l_pd',
]
